import React from 'react';
import { COLORS } from '../../styles/tokens';

// Liten tellerbadge oppe til høyre på et fane-ikon. Skjules når count er 0.
export default function TabBadge({ count }) {
  if (!count || count < 1) return null;
  return (
    <span data-testid="tab-badge" aria-hidden="true" style={styles.badge}>{count > 9 ? '9+' : count}</span>
  );
}

const styles = {
  badge: {
    position: 'absolute', top: -3, right: 2, minWidth: 16, height: 16, padding: '0 4px', boxSizing: 'border-box',
    borderRadius: 8, background: COLORS.danger, color: '#fff', fontSize: 10, fontWeight: 700, lineHeight: '16px',
    textAlign: 'center', border: `1.5px solid ${COLORS.white}`,
  },
};
